export const FLAGSHIP_EVENT_TYPE = 'flagship';

export const REGULAR_EVENTS_LIST_FILTERS = {
  excludeEventTypes: [FLAGSHIP_EVENT_TYPE],
};

export const FLAGSHIP_EVENTS_LIST_FILTERS = {
  eventType: FLAGSHIP_EVENT_TYPE,
};
